import automators from "../images/automators.jpg";
import umpod from "../images/umpod.png";
import alethinos from "../images/alethinos.png";
import mc from "../images/mc.webp";

export const experience = [
    {
        employer: "Automators s.r.o.",
        position: "Test automation specialist",
        between: "since 11/2022",
        logo: automators,
        bio: "With Automators I am testing application development projects, with Cypress and Tosca among others, focusing mainly on Front-end and API testing. I can also perform less complex developer tasks.",
        id: 1
    },
    {
        employer: "Office of International Legal Protection of Children",
        position: "Lawyer",
        between: "2017-2022",
        logo: umpod,
        bio: "I provided clients with legal support and guidance in the field of international private (family) law, also representing children at court proceedings. I also provided medition services both in Czech and English language.",
        id: 2
    },
    {
        employer: "Mediation Centre Brno",
        position: "Mediator",
        between: "2018-2021",
        logo: mc,
        bio: "I provided with professional family mediation services in Czech and English, focusing on transformative mediation model.",
        id: 3
    },
    {
        employer: "Mgr. Adam Russ, attorney",
        position: "Associate of law firm",
        between: "2016-2017",
        logo: alethinos,
        bio: "I worked as an associate at law firm with general legal practise.",
        id: 4
    }
];